import sCalendarRange from '../calendar/calendar-range'
import sTimeRange from '../time/time-range'
import { assignTime, isValidRangeDate, pick } from 'toolkit/utils/date'

export default {
  name: 'sDateTimeRange',
  inject: {
    prefixClass: {
      default: 's-datepicker',
    },
  },
  emits: ['select', 'update:show-time-panel'],
  props: {
    ...sCalendarRange.props,
    ...sTimeRange.props,
    showTimePanel: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value,
    }
  },
  computed: {
    timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible
    },
  },
  watch: {
    value(val) {
      this.currentValue = val
    },
  },
  methods: {
    closeTimePanel() {
      this.defaultTimeVisible = false
      this.$emit('update:show-time-panel', false)
    },
    openTimePanel() {
      this.defaultTimeVisible = true
      this.$emit('update:show-time-panel', true)
    },
    emitDate(dates, type) {
      this.$emit('select', dates, type)
    },
    handleSelect(dates, type) {
      if (type === 'date') {
        this.openTimePanel()
      }
      const defaultValues = Array.isArray(this.defaultValue)
        ? this.defaultValue
        : [this.defaultValue, this.defaultValue]
      let datetimes = dates.map((date, i) => {
        const time = isValidRangeDate(this.value) ? this.value[i] : defaultValues[i]
        return assignTime(date, time)
      })
      if (datetimes[1].getTime() < datetimes[0].getTime()) {
        datetimes = [datetimes[0], datetimes[0]]
      }
      if (datetimes.some(this.disabledTime)) {
        datetimes = dates.map((date, i) => assignTime(date, defaultValues[i]))
        if (datetimes.some(this.disabledTime)) {
          this.currentValue = datetimes
          return
        }
      }
      this.emitDate(datetimes, type)
    },
  },
  render() {
    const calendarProps = {
      props: {
        ...pick(this.$props, Object.keys(sCalendarRange.props)),
        type: 'date',
        value: this.currentValue,
      },
      on: {
        select: this.handleSelect,
      },
    }
    const timeProps = {
      props: {
        ...pick(this.$props, Object.keys(sTimeRange.props)),
        value: this.currentValue,
        showTimeHeader: true,
      },
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel,
      },
    }

    const { prefixClass } = this

    return (
      <div>
        <sCalendarRange {...calendarProps} />
        {this.timeVisible && <sTimeRange class={`${prefixClass}-calendar-time`} {...timeProps} />}
      </div>
    )
  },
}